import { toast } from 'sonner'

/** A single shared id so a repeated error replaces the previous toast instead of stacking. */
const ERROR_TOAST_ID = 'app-error-toast'

/** Auto-dismiss after a few seconds so a transient failure clears itself. */
const ERROR_TOAST_DURATION_MS = 5000

/**
 * Error toasts reuse one id, so repeated failures (e.g. re-submitting an invalid
 * form) replace the current toast rather than stacking window-on-window, and they
 * auto-dismiss after a few seconds. The Toaster still renders a close button for
 * manual dismissal.
 */
export const showErrorToast = (message: string): void => {
  toast.error(message, { id: ERROR_TOAST_ID, duration: ERROR_TOAST_DURATION_MS })
}

/** Confirmation for actions that complete without a page navigation (no server flash). */
export const showSuccessToast = (message: string): void => {
  toast.success(message)
}
